import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Quote } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    quote: 'Por primera vez entendí la diferencia entre facilitar e inhibir un músculo. Cambió completamente mi forma de aplicar la cinta.',
    author: 'Fisioterapeuta, práctica privada'
  }, {
    quote: 'El protocolo de fascitis plantar lo apliqué al día siguiente de leerlo. El paciente sintió alivio inmediato. Increíble.',
    author: 'Masajista terapéutico deportivo'
  }, {
    quote: 'Lo que más valoro es la sección de poblaciones especiales. Trabajo con adultos mayores y nunca había tenido una guía tan clara sobre cómo adaptar la técnica.',
    author: 'Terapeuta físico en centro geriátrico'
  }, {
    quote: 'La guía de tensiones me resolvió la duda que tenía desde hace dos años. Siempre aplicaba la misma tensión para todo. Ahora entiendo por qué no siempre funcionaba.',
    author: 'Kinesiólogo, clínica de rehabilitación'
  }];
  return <section className="py-16 px-4 bg-navy-800 relative" data-id="element-261">
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-gold-500/30 to-transparent" data-id="element-262"></div>

      <div className="max-w-5xl mx-auto" data-id="element-263">
        <FadeIn data-id="element-264">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-center text-cream-100 mb-10 max-w-3xl mx-auto" data-id="element-265">
            Esto es lo que dicen los profesionales que ya aplican este sistema:
          </h2>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-266">
          {testimonials.map((test, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-267">
              <div className="bg-navy-900 p-8 rounded-sm border border-navy-700 relative h-full flex flex-col justify-between" data-id="element-268">
                <Quote className="absolute top-6 right-6 w-8 h-8 text-gold-500/20" data-id="element-269" />
                <p className="text-cream-200 italic text-lg leading-relaxed mb-6 relative z-10" data-id="element-270">
                  "{test.quote}"
                </p>
                <div className="border-t border-navy-700 pt-4" data-id="element-271">
                  <p className="text-gold-400 font-medium text-sm uppercase tracking-wider" data-id="element-272">
                    — {test.author}
                  </p>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}